import React from 'react';
import { TableCellProps } from '../../../types/search';

const PortalCellService: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--waste-type`}>
      <div className="portal-cell__icon">
        <svg className="icon" aria-hidden="true">
          <use href="/dist/assets/icons/sprite.svg#general-waste"></use>
        </svg>
      </div>
      <div>
        <p>
          <strong>{value}</strong>
        </p>
        {row.containerType ? <p>{row.containerType}</p> : null}
      </div>
    </div>
  );
};

export default PortalCellService;
